import * as constants from '@core/js/store/constants';
import { staticReducers as coreStaticReducers } from '@core/js/store/staticReducers';

import { reducer as registrationReducer } from '@interlayer/js/app/store/reducers/Registration/reducer';
import { reducer as fundsTransferReducer } from '@interlayer/js/app/store/reducers/FundsTransfer/reducer';
import { reducer as responsibleGamingReducer } from '@interlayer/js/app/store/reducers/ResponsibleGaming/reducer';
import { reducer as postCodeReducer } from '@interlayer/js/app/store/reducers/postCodeFinder/reducer';
import { reducer as clubsReducer } from '@interlayer/js/app/store/reducers/clubsService/reducer';
import { reducer as recentlyGamesReducer } from '@interlayer/js/app/store/reducers/recentlyGames/reducer';
import { reducer as pageReducer } from '@interlayer/js/components/system/Page/store/reducer';
import { reducer as appReducer } from '@interlayer/js/components/system/App/store/reducer';
import { reducer as userReducer } from '@interlayer/js/hooks/user/store/reducer';
import { reducer as jackpotsReducer } from '@interlayer/js/components/common/Jackpot/store/reducer';

import { REDUCER_NAMES } from '@interlayer/js/app/store/constants';

export const staticReducers = {
    ...coreStaticReducers,
    [constants.USER_REDUCER]: userReducer,
    [constants.JACKPOTS_REDUCER]: jackpotsReducer,
    [constants.APP_REDUCER]: appReducer,
    [constants.PAGE_REDUCER]: pageReducer,
    [REDUCER_NAMES.registration]: registrationReducer,
    [REDUCER_NAMES.fundsTransfer]: fundsTransferReducer,
    [REDUCER_NAMES.responsibleGaming]: responsibleGamingReducer,
    [REDUCER_NAMES.postCode]: postCodeReducer,
    [REDUCER_NAMES.clubs]: clubsReducer,
    [REDUCER_NAMES.recentlyGames]: recentlyGamesReducer
};
